export const CLAVES_COLUMNAS = [
  { clave: 'fullName', visible: false, dataset: 1, validacion: 'alfabetica' },
  { clave: 'ownKey', visible: false, dataset: 1, validacion: 'alfanumerica' },
  { clave: 'age', visible: false, dataset: 1, validacion: 'numerica' },
  { clave: 'surveyKey', visible: false, dataset: 1, validacion: 'alfanumerica' },
  { clave: 'email', visible: false, dataset: 1, validacion: 'email' },
  { clave: 'bossName', visible: false, dataset: 1, validacion: 'alfanumerica' },
  { clave: 'bossKey', visible: false, dataset: 1, validacion: 'alfanumerica' },
  { clave: 'country', visible: false, dataset: 1, validacion: 'alfabetica' },
  { clave: 'location', visible: false, dataset: 1, validacion: 'alfanumerica' },
  { clave: 'geo_1', visible: false, dataset: 2, validacion: 'alfanumerica' },
  { clave: 'geo_2', visible: false, dataset: 2, validacion: 'alfanumerica' },
  { clave: 'geo_3', visible: false, dataset: 2, validacion: 'alfanumerica' },
  { clave: 'geo_4', visible: false, dataset: 2, validacion: 'alfanumerica' },
  { clave: 'geo_5', visible: false, dataset: 2, validacion: 'alfanumerica' },
  { clave: 'geo_6', visible: false, dataset: 2, validacion: 'alfanumerica' },
  { clave: 'geo_7', visible: false, dataset: 2, validacion: 'alfanumerica' },
  { clave: 'geo_8', visible: false, dataset: 2, validacion: 'alfanumerica' },
  { clave: 'geo_9', visible: false, dataset: 2, validacion: 'alfanumerica' },
  { clave: 'geo_10', visible: false, dataset: 2, validacion: 'alfanumerica' },
  { clave: 'structure_1', visible: false, dataset: 3, validacion: 'alfanumerica' },
  { clave: 'structure_2', visible: false, dataset: 3, validacion: 'alfanumerica' },
  { clave: 'structure_3', visible: false, dataset: 3, validacion: 'alfanumerica' },
  { clave: 'structure_4', visible: false, dataset: 3, validacion: 'alfanumerica' },
  { clave: 'structure_5', visible: false, dataset: 3, validacion: 'alfanumerica' },
  { clave: 'structure_6', visible: false, dataset: 3, validacion: 'alfanumerica' },
  { clave: 'structure_7', visible: false, dataset: 3, validacion: 'alfanumerica' },
  { clave: 'structure_8', visible: false, dataset: 3, validacion: 'alfanumerica' },
  { clave: 'structure_9', visible: false, dataset: 3, validacion: 'alfanumerica' },
  { clave: 'structure_10', visible: false, dataset: 3, validacion: 'alfanumerica' },
  { clave: 'area', visible: false, dataset: 4, validacion: 'alfabetica' },
  { clave: 'bUnit', visible: false, dataset: 4, validacion: 'alfabetica' },
  { clave: 'enterDate', visible: false, dataset: 4, validacion: 'alfabetica' },
  { clave: 'antiquity', visible: false, dataset: 4, validacion: 'alfabetica' },
  { clave: 'antiquityUS', visible: false, dataset: 4, validacion: 'alfabetica' },
  { clave: 'generation', visible: false, dataset: 4, validacion: 'alfanumerica' },
  { clave: 'generationUS', visible: false, dataset: 4, validacion: 'alfabetica' },
  { clave: 'ageUS', visible: false, dataset: 4, validacion: 'alfanumerica' },
  { clave: 'charge', visible: false, dataset: 5, validacion: 'alfabetica' },
  { clave: 'homologado', visible: false, dataset: 5, validacion: 'alfanumerica' },
  { clave: 'homologadoUS', visible: false, dataset: 5, validacion: 'alfanumerica' },
  { clave: 'gender', visible: false, dataset: 5, validacion: 'alfanumerica' },
  { clave: 'genderType', visible: false, dataset: 5, validacion: 'alfabetica' },
  { clave: 'typeofwork', visible: false, dataset: 5, validacion: 'alfabetica' },
  { clave: 'workCondition', visible: false, dataset: 5, validacion: 'alfanumerica' },
  { clave: 'academico', visible: false, dataset: 5, validacion: 'alfanumerica' },
  { clave: 'contratacion', visible: false, dataset: 5, validacion: 'alfanumerica' },
  { clave: 'situacionUS', visible: false, dataset: 6, validacion: 'alfanumerica' },
  { clave: 'personal', visible: false, dataset: 6, validacion: 'alfanumerica' },
  { clave: 'jornada', visible: false, dataset: 6, validacion: 'alfanumerica' },
  { clave: 'rotacion', visible: false, dataset: 6, validacion: 'alfanumerica' },
  { clave: 'phone', visible: false, dataset: 6, validacion: 'numerica' },
  { clave: 'extension', visible: false, dataset: 6, validacion: 'numerica' },
  { clave: 'cellphone', visible: false, dataset: 6, validacion: 'numerica' },
  { clave: 'native', visible: false, dataset: 6, validacion: 'alfanumerica' },
  { clave: 'answer', visible: false, dataset: 6, validacion: 'alfanumerica' },
  { clave: 'other_1', visible: false, dataset: 7, validacion: 'alfanumerica' },
  { clave: 'other_2', visible: false, dataset: 7, validacion: 'alfanumerica' },
  { clave: 'other_3', visible: false, dataset: 7, validacion: 'alfanumerica' },
  { clave: 'other_4', visible: false, dataset: 7, validacion: 'alfanumerica' },
  { clave: 'other_5', visible: false, dataset: 7, validacion: 'alfanumerica' },
  { clave: 'other_6', visible: false, dataset: 7, validacion: 'alfanumerica' },
  { clave: 'other_7', visible: false, dataset: 7, validacion: 'alfanumerica' },
  { clave: 'other_8', visible: false, dataset: 7, validacion: 'alfanumerica' },
  { clave: 'other_9', visible: false, dataset: 7, validacion: 'alfanumerica' },
  { clave: 'other_10', visible: false, dataset: 7, validacion: 'alfanumerica' },
];

export const COLUMNAS_MX = [
  { clave: 'fullName', obligatorio: true },
  { clave: 'ownKey', obligatorio: true },
  { clave: 'age', obligatorio: false },
  { clave: 'surveyKey', obligatorio: true },
  { clave: 'email', obligatorio: true },
  { clave: 'bossName', obligatorio: true },
  { clave: 'bossKey', obligatorio: true },
  { clave: 'country', obligatorio: true },
  { clave: 'location', obligatorio: true },
  { clave: 'geo_1', obligatorio: false },
  { clave: 'geo_2', obligatorio: false },
  { clave: 'geo_3', obligatorio: false },
  { clave: 'geo_4', obligatorio: false },
  { clave: 'geo_5', obligatorio: false },
  { clave: 'structure_1', obligatorio: false },
  { clave: 'structure_2', obligatorio: false },
  { clave: 'structure_3', obligatorio: false },
  { clave: 'structure_4', obligatorio: false },
  { clave: 'structure_5', obligatorio: false },
  { clave: 'structure_6', obligatorio: false },
  { clave: 'structure_7', obligatorio: false },
  { clave: 'structure_8', obligatorio: false },
  { clave: 'structure_9', obligatorio: false },
  { clave: 'structure_10', obligatorio: false },
  { clave: 'area', obligatorio: true },
  { clave: 'enterDate', obligatorio: true },
  { clave: 'antiquity', obligatorio: true },
  { clave: 'antiquityUS', obligatorio: false },
  { clave: 'generation', obligatorio: true },
  { clave: 'generationUS', obligatorio: false },
  { clave: 'ageUS', obligatorio: true },
  { clave: 'charge', obligatorio: true },
  { clave: 'homologado', obligatorio: true },
  { clave: 'homologadoUS', obligatorio: true },
  { clave: 'gender', obligatorio: true },
  { clave: 'typeofwork', obligatorio: true },
  { clave: 'workCondition', obligatorio: true },
  { clave: 'academico', obligatorio: true },
  { clave: 'contratacion', obligatorio: true },
  { clave: 'situacionUS', obligatorio: false },
  { clave: 'personal', obligatorio: true },
  { clave: 'jornada', obligatorio: true },
  { clave: 'rotacion', obligatorio: true },
  { clave: 'phone', obligatorio: true },
  { clave: 'extension', obligatorio: true },
  { clave: 'cellphone', obligatorio: true },
  { clave: 'native', obligatorio: true },
  { clave: 'answer', obligatorio: true }
];

export const COLUMNAS_CAYC = [
  { clave: 'fullName', obligatorio: true },
  { clave: 'ownKey', obligatorio: true },
  { clave: 'age', obligatorio: true },
  { clave: 'surveyKey', obligatorio: true },
  { clave: 'email', obligatorio: true },
  { clave: 'bossName', obligatorio: false },
  { clave: 'bossKey', obligatorio: false },
  { clave: 'country', obligatorio: true },
  { clave: 'location', obligatorio: true },
  { clave: 'geo_1', obligatorio: false },
  { clave: 'geo_2', obligatorio: false },
  { clave: 'structure_1', obligatorio: false },
  { clave: 'structure_2', obligatorio: false },
  { clave: 'structure_3', obligatorio: false },
  { clave: 'structure_4', obligatorio: false },
  { clave: 'structure_5', obligatorio: false },
  { clave: 'area', obligatorio: true },
  { clave: 'enterDate', obligatorio: true },
  { clave: 'antiquity', obligatorio: true },
  { clave: 'generation', obligatorio: true },
  { clave: 'charge', obligatorio: true },
  { clave: 'homologado', obligatorio: true },
  { clave: 'gender', obligatorio: true },
  // { clave: 'genderType', obligatorio: true },
  { clave: 'workCondition', obligatorio: true },
  { clave: 'academico', obligatorio: false },
  { clave: 'phone', obligatorio: true },
  { clave: 'extension', obligatorio: false },
  { clave: 'cellphone', obligatorio: false },
  { clave: 'native', obligatorio: false },
  { clave: 'answer', obligatorio: true }
];

export const COLUMNAS_HK = [
  { clave: 'fullName', obligatorio: true },
  { clave: 'ownKey', obligatorio: true },
  { clave: 'email', obligatorio: true },
  { clave: 'bossName', obligatorio: false },
  { clave: 'bossKey', obligatorio: false },
  { clave: 'country', obligatorio: false },
  { clave: 'location', obligatorio: true },
  { clave: 'geo_1', obligatorio: false },
  { clave: 'geo_2', obligatorio: false },
  { clave: 'geo_3', obligatorio: false },
  { clave: 'geo_4', obligatorio: false },
  { clave: 'geo_5', obligatorio: false },
  { clave: 'structure_1', obligatorio: false },
  { clave: 'structure_2', obligatorio: false },
  { clave: 'structure_3', obligatorio: false },
  { clave: 'structure_4', obligatorio: false },
  { clave: 'structure_5', obligatorio: false },
  { clave: 'structure_6', obligatorio: false },
  { clave: 'structure_7', obligatorio: false },
  { clave: 'structure_8', obligatorio: false },
  { clave: 'structure_9', obligatorio: false },
  { clave: 'structure_10', obligatorio: false },
  { clave: 'area', obligatorio: true },
  { clave: 'bUnit', obligatorio: false },
  { clave: 'homologado', obligatorio: true },
  { clave: 'gender', obligatorio: true },
  { clave: 'typeofwork', obligatorio: true },
  { clave: 'workCondition', obligatorio: true },
  { clave: 'academico', obligatorio: true },
  { clave: 'phone', obligatorio: false },
  { clave: 'native', obligatorio: true },
  { clave: 'answer', obligatorio: true },
  { clave: 'other_1', obligatorio: false },
  { clave: 'other_2', obligatorio: false },
  { clave: 'other_3', obligatorio: false },
  { clave: 'other_4', obligatorio: false },
  { clave: 'other_5', obligatorio: false },
  { clave: 'other_6', obligatorio: false },
  { clave: 'other_7', obligatorio: false },
  { clave: 'other_8', obligatorio: false },
  { clave: 'other_9', obligatorio: false },
  { clave: 'other_10', obligatorio: false },
];

export const COLUMNAS_TR = [
  { clave: 'fullName', obligatorio: true },
  { clave: 'ownKey', obligatorio: true },
  { clave: 'age', obligatorio: false },
  { clave: 'email', obligatorio: true },
  { clave: 'bossName', obligatorio: true },
  { clave: 'bossKey', obligatorio: true },
  { clave: 'country', obligatorio: true },
  { clave: 'location', obligatorio: true },
  { clave: 'geo_1', obligatorio: false },
  { clave: 'geo_2', obligatorio: false },
  { clave: 'geo_3', obligatorio: false },
  { clave: 'geo_4', obligatorio: false },
  { clave: 'geo_5', obligatorio: false },
  { clave: 'geo_6', obligatorio: false },
  { clave: 'geo_7', obligatorio: false },
  { clave: 'geo_8', obligatorio: false },
  { clave: 'geo_9', obligatorio: false },
  { clave: 'geo_10', obligatorio: false },
  { clave: 'structure_1', obligatorio: false },
  { clave: 'structure_2', obligatorio: false },
  { clave: 'structure_3', obligatorio: false },
  { clave: 'structure_4', obligatorio: false },
  { clave: 'structure_5', obligatorio: false },
  { clave: 'structure_6', obligatorio: false },
  { clave: 'structure_7', obligatorio: false },
  { clave: 'structure_8', obligatorio: false },
  { clave: 'structure_9', obligatorio: false },
  { clave: 'structure_10', obligatorio: false },
  { clave: 'area', obligatorio: false },
  { clave: 'enterDate', obligatorio: false },
  { clave: 'antiquity', obligatorio: false },
  { clave: 'generation', obligatorio: false },
  { clave: 'charge', obligatorio: false },
  { clave: 'gender', obligatorio: false },
  { clave: 'genderType', obligatorio: false },
  { clave: 'workCondition', obligatorio: false },
  { clave: 'academico', obligatorio: false },
  { clave: 'contratacion', obligatorio: false },
  { clave: 'personal', obligatorio: false },
  { clave: 'jornada', obligatorio: false },
  { clave: 'rotacion', obligatorio: false },
  { clave: 'phone', obligatorio: false },
  { clave: 'native', obligatorio: true },
  { clave: 'answer', obligatorio: true },
];

export const COLUMNAS_WWDE = [
  { clave: 'fullName', obligatorio: true },
  { clave: 'ownKey', obligatorio: true },
  { clave: 'age', obligatorio: false },
  { clave: 'surveyKey', obligatorio: true },
  { clave: 'email', obligatorio: true },
  { clave: 'bossName', obligatorio: true },
  { clave: 'bossKey', obligatorio: true },
  { clave: 'country', obligatorio: true },
  { clave: 'location', obligatorio: true },
  { clave: 'geo_1', obligatorio: false },
  { clave: 'geo_2', obligatorio: false },
  { clave: 'geo_3', obligatorio: false },
  { clave: 'geo_4', obligatorio: false },
  { clave: 'geo_5', obligatorio: false },
  { clave: 'structure_1', obligatorio: false },
  { clave: 'structure_2', obligatorio: false },
  { clave: 'structure_3', obligatorio: false },
  { clave: 'structure_4', obligatorio: false },
  { clave: 'structure_5', obligatorio: false },
  { clave: 'structure_6', obligatorio: false },
  { clave: 'structure_7', obligatorio: false },
  { clave: 'structure_8', obligatorio: false },
  { clave: 'structure_9', obligatorio: false },
  { clave: 'structure_10', obligatorio: false },
  { clave: 'area', obligatorio: true },
  { clave: 'enterDate', obligatorio: true },
  { clave: 'antiquity', obligatorio: true },
  { clave: 'generation', obligatorio: true },
  { clave: 'charge', obligatorio: true },
  { clave: 'homologado', obligatorio: false },
  { clave: 'gender', obligatorio: true },
  { clave: 'typeofwork', obligatorio: true },
  { clave: 'workCondition', obligatorio: true },
  { clave: 'academico', obligatorio: false },
  { clave: 'contratacion', obligatorio: false },
  { clave: 'personal', obligatorio: false },
  { clave: 'jornada', obligatorio: false },
  { clave: 'rotacion', obligatorio: false },
  { clave: 'phone', obligatorio: false },
  { clave: 'extension', obligatorio: true },
  { clave: 'cellphone', obligatorio: true },
  { clave: 'native', obligatorio: true },
  { clave: 'answer', obligatorio: true }
];

//años para realizar comparaciones
export const CAT_GENERACION = [
  1927,
  1945,
  1964,
  1980,
  1997,
  1998
];
export const CAT_GENERACION_US= [
  // 1945,
  1964,
  1980,
  1997,
  1998
];
export const CAT_EDAD_US = [
  25,
  34,
  44,
  54,
  55
];
//antiguedades transformadas a maximo de meses
export const CAT_ANTIGUEDAD = [
  3,
  24,
  60,
  120,
  180,
  240,
  241
];
export const CAT_ANTIGUEDAD_CAYC = [
  24,
  60,
  120,
  180,
  240,
  241
];
export const CAT_ANTIGUEDAD_US = [
  24,
  60,
  120,
  180,
  240,
  241
];
